// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marketplace-logs-container {
  flex-wrap: unset;
}
.marketplace-logs-container .main-content__sidebar {
  width: unset;
}
.marketplace-logs-container .marketplace-logs-table {
  position: relative;
  overflow: auto hidden;
}
.marketplace-logs-container .marketplace-logs-table span {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
  padding: 3px;
  cursor: pointer;
}
.marketplace-logs-container .marketplace-logs-table .rdt_TableCol {
  padding: 0;
}
.marketplace-logs-container .marketplace-logs-table .row-reason-cell {
  position: relative;
  width: 100%;
}
.marketplace-logs-container .marketplace-logs-table .row-reason-cell p {
  margin-right: 1rem;
}
.marketplace-logs-container .marketplace-logs-table .row-reason-cell small {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0 5px;
}
.marketplace-logs-container .marketplace-logs-table .buttons-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 45px;
}
.marketplace-logs-container .marketplace-logs-table .buttons-wrapper .button--primary,
.marketplace-logs-container .marketplace-logs-table .buttons-wrapper .button--simple,
.marketplace-logs-container .marketplace-logs-table .buttons-wrapper .button--grey,
.marketplace-logs-container .marketplace-logs-table .buttons-wrapper .button--error {
  height: 56px;
  display: flex;
  justify-content: center;
}
.marketplace-logs-container .marketplace-logs-table .buttons-wrapper .button--primary {
  margin-left: 16px;
}
.marketplace-logs-container .logs-id-filters {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 20px;
}
.marketplace-logs-container .logs-id-filters div {
  width: 200px;
}
.marketplace-logs-container div[id*=row-]:hover {
  background-color: rgb(242.25, 242.25, 242.25);
}
.marketplace-logs-container div[id*=cell-] {
  padding: 0 5px;
}
.marketplace-logs-container div[id*=cell-]:not(:last-child) {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.marketplace-logs-container .bsgpsK div:first-child {
  white-space: initial;
}

.logs-reason-modal .modal {
  width: 90vw;
}

.logs-reason-details {
  height: 75vh;
  resize: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/Logs/MarketplaceLogs/ShopInvoice.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAAE;EACE,YAAA;AAEJ;AAAE;EACE,kBAAA;EACA,qBAAA;AAEJ;AADI;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAGN;AADI;EACE,UAAA;AAGN;AADI;EACE,kBAAA;EACA,WAAA;AAGN;AAFM;EACE,kBAAA;AAIR;AAFM;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;AAIR;AADI;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAGN;AAFM;;;;EAIE,YAAA;EACA,aAAA;EACA,uBAAA;AAIR;AAFM;EACE,iBAAA;AAIR;AAAE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAEJ;AADI;EACE,YAAA;AAGN;AACE;EACE,6CAAA;AACJ;AACE;EACE,cAAA;AACJ;AAAI;EACE,2CAAA;AAEN;AAEE;EACE,oBAAA;AAAJ;;AAIE;EACE,WAAA;AADJ;;AAIA;EACE,YAAA;EACA,YAAA;AADF","sourcesContent":[".marketplace-logs-container {\n  flex-wrap: unset;\n  .main-content__sidebar {\n    width: unset;\n  }\n  .marketplace-logs-table {\n    position: relative;\n    overflow: auto hidden;\n    span {\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-align: left;\n      padding: 3px;\n      cursor: pointer;\n    }\n    .rdt_TableCol {\n      padding: 0;\n    }\n    .row-reason-cell {\n      position: relative;\n      width: 100%;\n      p {\n        margin-right: 1rem;\n      }\n      small {\n        position: absolute;\n        bottom: 0;\n        right: 0;\n        padding: 0 5px;\n      }\n    }\n    .buttons-wrapper {\n      display: flex;\n      justify-content: space-between;\n      margin-top: 45px;\n      .button--primary,\n      .button--simple,\n      .button--grey,\n      .button--error {\n        height: 56px;\n        display: flex;\n        justify-content: center;\n      }\n      .button--primary {\n        margin-left: 16px;\n      }\n    }\n  }\n  .logs-id-filters {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-top: 20px;\n    div {\n      width: 200px;\n    }\n  }\n\n  div[id*=\"row-\"]:hover {\n    background-color: darken($color: white, $amount: 5%);\n  }\n  div[id*=\"cell-\"] {\n    padding: 0 5px;\n    &:not(:last-child) {\n      border-right: 1px solid rgba(0, 0, 0, 0.12);\n    }\n  }\n\n  .bsgpsK div:first-child {\n    white-space: initial;\n  }\n}\n.logs-reason-modal {\n  .modal {\n    width: 90vw;\n  }\n}\n.logs-reason-details {\n  height: 75vh;\n  resize: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
